import React, { useState, useEffect } from "react";
import "./Index.css";

const PreBuiltSolutions = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const items = [
    {
      title: "Sales Force Automation (SFA)",
      description:
        "The ready-to-deploy DMS is a complete solution for OEMs, distributors, and dealers, offering primary sales data management to streamline operations and enhance efficiency.",
      image: require("../../assets/img/image 29.jpg"),
    },
    {
      title: "DMS (Secondary Solutions)",
      description:
        "The ready-to-deploy DMS is a complete solution for OEMs, distributors, and dealers, offering primary sales data management to streamline operations and enhance efficiency.",
      image: require("../../assets/img/image 29.jpg"),
    },
    {
      title: "WhatsApp Integrator",
      description:
        "The ready-to-deploy DMS is a complete solution for OEMs, distributors, and dealers, offering primary sales data management to streamline operations and enhance efficiency.",
      image: require("../../assets/img/image 29.jpg"),
    },
    {
      title: "Loan Origination System (LOS)",
      description:
        "The ready-to-deploy DMS is a complete solution for OEMs, distributors, and dealers, offering primary sales data management to streamline operations and enhance efficiency.",
      image: require("../../assets/img/image 29.jpg"),
    },
    {
      title: "Org Analysis",
      description:
        "The ready-to-deploy DMS is a complete solution for OEMs, distributors, and dealers, offering primary sales data management to streamline operations and enhance efficiency.",
      image: require("../../assets/img/image 29.jpg"),
    },
    {
      title: "DocGenX",
      description:
        "The ready-to-deploy DMS is a complete solution for OEMs, distributors, and dealers, offering primary sales data management to streamline operations and enhance efficiency.",
      image: require("../../assets/img/image 29.jpg"),
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) =>
        prevIndex === items.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000); // Change item every 3 seconds

    return () => clearInterval(interval);
  }, []);

  const handlePrev = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === 0 ? items.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === items.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handleItemClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <div className="bg-blue-50 py-20 background-gradient background-gradient-2">
      <h2 className="text-center text-3xl font-bold mb-6">
        Other Pre-Built Solutions
      </h2>
      <div className="relative max-w-7xl mx-auto flex items-center">
        {/* Left Navigation Arrow */}
        <button
          onClick={handlePrev}
          className="absolute left-0 z-10 p-3 hover:bg-gray-100 focus:outline-none hidden lg:block"
        >
          <img
            src={require("../../assets/img/arrow (2).png")}
            alt="Previous"
            className="w-3 h-6"
          />
        </button>

        {/* Scrollable Container */}
        <div
          className="flex w-full overflow-hidden scroll-smooth relative space-x-4 gap-2 mx-12 custom-scroll "
        >
          {items.map((item, index) => (
            <div
              key={index}
              className={`ease-in-out flex-shrink-0 transition-all duration-300  ${
                index === activeIndex
                  ? "flex-1 bg-white p-4 rounded-xl shadow-lg transform scale-95 relative z-10 opacity-100"
                  : "flex-1 bg-white p-16 rounded-xl shadow-md transform scale-95"
              }`}
              style={{
                height: "500px",
                marginLeft: "12px", // No left margin for the first item
                marginRight: "0", // Apply consistent right margin
                minWidth: index === activeIndex ? "400px" : "100px",
                maxWidth: index === activeIndex ? "400px" : "100px",
                overflow: "hidden",
              }}
              onClick={() => handleItemClick(index)}
            >
              {index === activeIndex ? (
                <div className="flex flex-col items-center w-full h-full">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-48 object-cover rounded-md mb-4"
                  />
                  <div className="items-start">
                    <h3 className="text-2xl font-semibold text-start mb-2 text-[#0D89C8]">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 text-start text-xl my-4 leading-loose">
                      {item.description}
                    </p>
                    <button className="text-[#252525] font-[500] text-xl text-start m-3 mt-12 ml-0 mb-0 flex flex-row ">
                      Read More <div className=" p-1 "><img src={require('../../assets/img/Right arrow.png')} alt="arrow" width={26} height={2}/></div>
                    </button>
                  </div>
                </div>
              ) : (
                <div className="flex justify-center items-center font-medium text-center h-full w-full cursor-pointer rotate-90 whitespace-nowrap">
                  <h1 className="text-3xl font-normal">{item.title}</h1>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Right Navigation Arrow */}
        <button
          onClick={handleNext}
          className="absolute right-0 z-10 p-6 hover:bg-gray-100 focus:outline-none hidden lg:block"
        >
          <img
            src={require("../../assets/img/arrow (3).png")}
            alt="Next"
            className="w-3 h-6"
          />
        </button>
      </div>
    </div>
  );
};

export default PreBuiltSolutions;
